
export const textTransform = {
    cap: 'capitalize'
  };